import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./index.css";
import App from "./App";
import LoginPage from "./components/AuthModal/Login_page";
import AutoLogin from "./components/AuthModal/AutoLogin";
import Error from "./components/alert/error";
import MaintenancePage from "./pages/Maintenance/Maintenance";
import { APP_ENV } from "./config";
import MainRouter from "./components/Mainrouter/MainRouter";

if (process.env.NODE_ENV === "development") {
  const root = ReactDOM.createRoot(document.getElementById("ttp-chat-bot"));
  const MrEmmanuel = {
    enabled: true,
    firstName: "Emmanuel",
    lastName: "Degrève",
    language: "fr",
    type: "ADMIN",
    status: "AUTO",
    situation: "active",
    institute: "ITAA",
    numeroAgreation: "10373845",
    agreationType: "mItaa",
    agreationTitle: "certified Tax Advisor",
    agreationParam: "externe",
    itaaStatus: "Ok",
    agreation: [],
    gender: "MALE",
    title: "Monsieur",
    salutation: "Cher Confrère",
    function: "Managing Director",
    isSecure: true,
    hasAgreedTerms: true,
    isUaAdmin: true,
    uaStatus: "VALIDATED",
    acceptCookies: false,
    activityCount: 44,
    id: 8650,
    mainEmail: "emmanuel.degreve@degandpartners.com",
    mainPhone: "+3222473939",
    userMobilePhone: {
      intlFormat: "+32 486 21 02 11",
      countryCode: "be",
    },
    hasPassword: true,
    email: [
      {
        id: 8282,
        email: "emmanuel.degreve@degandpartners.com",
        main: 1,
        ranking: 1,
        type: "PROFESSIONAL",
        isBounced: 0,
        isComplaint: 0,
        isInternal: false,
        blacklisted: false,
        blacklist_id: null,
      },
      {
        id: 48224,
        email: "emmanuel.degreve@users.tamtam.pro",
        main: 0,
        ranking: 2,
        type: "PERSONAL",
        isBounced: 0,
        isComplaint: 0,
        isInternal: true,
        blacklisted: false,
        blacklist_id: null,
      },
    ],
    phone: [
      {
        id: 78799,
        number: "+3222473939",
        main: 1,
        ranking: 1,
        type: "PRIVATE_MOBILE",
        lookupType: "FIXED LINE",
        countryCode: "be",
        intlFormat: "+32 2 247 39 39",
      },
      {
        id: 92841,
        number: "+32486210211",
        main: 0,
        ranking: 1,
        type: "PROFESSIONAL",
        lookupType: "MOBILE",
        countryCode: "be",
        intlFormat: "+32 486 21 02 11",
      },
      {
        id: 111486,
        number: "+3222473939",
        main: 1,
        ranking: 1,
        type: "PRIVATE",
        lookupType: "FIXED LINE",
        countryCode: "be",
        intlFormat: "+32 2 247 39 39",
      },
    ],
    url: "emmanuel-degreve",
    creator: {
      id: 71367,
      organizations: [],
    },
  };

  const otherUser = {
    enabled: true,
    firstName: "Nick",
    lastName: "Bullynck",
    language: "nl",
    type: "USER",
    status: "CREATED",
    institute: "",
    numeroAgreation: "",
    gender: "MALE",
    title: "De heer",
    salutation: "",
    function: "",
    isSecure: true,
    hasAgreedTerms: false,
    isUaAdmin: false,
    uaStatus: "PENDING",
    acceptCookies: true,
    id: 45937,
    mainEmail: "nick@centum.be",
    mainPhone: "+32495793987",
    userMobilePhone: {
      intlFormat: "+32 495 79 39 87",
      countryCode: "be",
    },
    hasPassword: true,
    email: [
      {
        id: 26399,
        email: "nick@centum.be",
        main: 1,
        ranking: 1,
        type: "PROFESSIONAL",
        description: "",
        isBounced: 0,
        isComplaint: 0,
        isInternal: false,
        blacklisted: false,
        blacklist_id: null,
      },
    ],
    phone: [
      {
        id: 20397,
        number: "+32495793987",
        main: 1,
        ranking: 1,
        type: "PRIVATE_MOBILE",
        description: "",
        lookupType: "MOBILE",
        countryCode: "be",
        intlFormat: "+32 495 79 39 87",
      },
    ],
    url: "nick-bullynck",
  };

  root.render(
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage env={APP_ENV} />} />
        <Route path="/autologin" element={<AutoLogin />} />
        <Route path="/error" element={<Error />} />
        <Route
          path="/"
          element={
            <App
              token={"b189b97eaa2a9f0fee96449e69f34787af3bdc8c"}
              user={MrEmmanuel}
              lng={"fr"}
            />
          }
        />
      </Routes>
    </Router>
  );
} else {
  window.chatBotWidget = {
    mount: (props, container) => {
      const tmpRoot = ReactDOM.createRoot(container);
      tmpRoot.render(<App {...props} />);
    },
    unmount: (container) => {
      const tmpRoot = ReactDOM.createRoot(container);
      tmpRoot.unmount();
    },
  };
}

// const root = ReactDOM.createRoot(document.getElementById("ttp-chat-bot"));
// root.render(<MainRouter />);

//reportWebVitals();
